import React from 'react';
import styles from './Select.module.css';

const Select = ({ label, name, onChange, error, onBlur, ...props }) => {
  return (
    <div className={styles.wrapper}>
      <label htmlFor={name} className={styles.label}>
        {label}
      </label>
      <select
        id={name}
        className={styles.select}
        onChange={onChange}
        onBlur={onBlur}
        {...props}
      ></select>
      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
};

export default Select;
